import React from 'react';
import { Form } from 'antd';
import Translate from 'react-translate-component';

import { formItemLayout } from 'constants/formItemLayout';
import withLanguageContext from 'components/hocs/withLanguageContext';

const Field = withLanguageContext(function TranslateField ({ isEn, en, ru, defaultText = '' }) {
    return (isEn ? en : ru) || ru || en || defaultText || null;
});

export default Field;

export const TranslateFormField = function TranslateFormItem({ label, en, ru, defaultText }) {
    return (
        <Form.Item
            wrapperCol={formItemLayout.wrapperCol}
            labelCol={formItemLayout.labelCol}
            label={label && <Translate content={label} />}
        >
            <Field ru={ru} en={en} defaultText={defaultText} />
        </Form.Item>
    );
};
